<div class="customRadios row justify-content-center">
  <div *ngFor="let item of optionCollection" class="col-12 col-md-4 col-lg-4 mb-2 mb-md-4">
    <div
      class="option h-100"
      [ngClass]="{ active: item.value == comparitor }"
      (click)="comparitor = item.value"
    >
      <div class="row text-md-center">
        <div class="col-4 col-md-12 mb-md-2">
          <div class="h-100">
            <img
              *ngIf="item.protein == undefined"
              class="my-auto"
              src="assets/images/{{ item.image }}.svg"
            />
            <canvas
              *ngIf="item.protein != undefined"
              baseChart
              [data]="doughnutValues(item)"
              [chartType]="doughnutChartType"
              [legend]="false"
              [options]="{ aspectRatio: 1 }"
              [colors]="doughnutColors"
            >
            </canvas>
          </div>
        </div>

        <div class="col-8 col-md-12">
          <div class="optionTitle mb-2">{{ swapPronouns(item.value) }}</div>
          <div *ngIf="item.protein == undefined" class="optionSubtitle">
            {{ swapPronouns(item.subtitle) }}
          </div>

          <div *ngIf="item.protein != undefined" class="optionSubtitle">
            <span class="bubble blue"></span><span *ngIf="item.tilda" class="tilda">~</span
            >{{ item.protein }}% protein
          </div>
          <div *ngIf="item.protein != undefined" class="optionSubtitle">
            <span class="bubble orange"></span><span *ngIf="item.tilda" class="tilda">~</span
            >{{ item.carbs }}% carb
          </div>
          <div *ngIf="item.protein != undefined" class="optionSubtitle">
            <span class="bubble yellow"></span><span *ngIf="item.tilda" class="tilda">~</span
            >{{ item.fats }}% fat
          </div>
        </div>
        <img
          *ngIf="info"
          src="assets/images/info.svg"
          (click)="showModal(item)"
          class="infoButton"
        />
      </div>
    </div>
  </div>
</div>
